import dashboard from './dashboard'
import report from './report'

// Array of sections
export default [...dashboard, ...report]
